<template>
  <div class="empty">
    <div class="empty-icon">
      <i class="fas fa-7x fa-tools"></i>
    </div>
    <p class="empty-title h5">{{ getCaption("caption.under_construction_title") }}</p>
    <p class="empty-subtitle">{{ getCaption("caption.under_construction_body") }}</p>
  </div>
</template>

<script>
import { transportationSchedule } from "@/constants/sidemenu.js";

export default {
  mounted() {
    this.setSidemenu();
  },

  methods: {
    setSidemenu() {
      this.$store.dispatch("setSidemenuData", {
        menu: transportationSchedule,
        parentType: "topmenu"
      });
    }
  }
};
</script>
